export default function ProducerContentContainer({ children, style }) {
  return (
    <div style={{ maxWidth: '980px', margin: '0 auto', width: '100%', boxSizing: 'border-box', ...style }}>
      {children}
    </div>
  );
}
